import styled,{ css } from 'styled-components';

export const Container= styled.div`
width:100%;
margin-top: 64px;
background-color:#FFFFFF;
display: flex;
flex-direction: column;
justify-content: flex-start;
z-index: 100;
overflow-y: scroll;
`;

export const EmojiText = styled.span`
font-family: Nunito;
font-style: normal;
font-weight: 600;
font-size: 14px;
line-height: 20px;
color: #303645;
`;

export const Emoji = styled.div`
height:52px;
width:52px;
display:flex;
flex-direction:row;
align-items:center;
`;

export const FeedbackText=styled(EmojiText)`
margin-top:24px;
margin-left:5%;
font-size: 16px;
line-height: 25px;
`;

export const EmojiContainer =styled.div`
margin-top:24px;
width:75%;
margin-left:12.5%;
height:84px;
display: flex;
flex-direction: row;
justify-content: space-between;
`;

export const Input = styled.textarea`
width:90%;
margin-left:5%;
height: 78px;
margin-top: 8px;
background: #FFFFFF;
border: 1px solid #E1E5EE;
box-sizing: border-box;
padding:9px;
border-radius: 8px;
maxLength:10;

font-family: Nunito;
font-style: normal;
font-weight: normal;
font-size: 14px;
line-height: 19px;
placeholderTextColor: #828999;
color:#303645;
text-decoration: none;
outline:none;
focus:none;

&:focus{
    border-color: #454ADE;
    border-width:2px;
}
`;

export const FeedbackTextLength= styled.span`
margin-top:8px;
margin-right:5%;
margin-bottom:90px;
font-family: Nunito;
font-style: normal;
font-weight: normal;
font-size: 12px;
line-height: 16px;
text-align: right;
color: #828999;
`;

export const Footer = styled.div`
position: fixed;
width: 100%;
height:81px;
left: 0;
bottom: 0;
background: #FFFFFF;
box-shadow: 0px -1px 20px rgba(0, 0, 0, 0.08);
border-radius: 0px;
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;
`;

export const SubmitBtn = styled.button`
width:90%;
height:48px;
background: #454ADE;
border-radius: 8px;
font-family: Nunito;
font-style: normal;
font-weight: bold;
font-size: 16px;
line-height: 24px;
color: #FFFFFF;
border:none;
outline:none;
${props=>
    props.disabled &&
    css`
    background:#C0C2FF;
`}
`;

export const CheckContainer = styled.div`
position: relative;
`;

export const CheckMark = styled.div<{
    checked:boolean;
}>`
${props=>
    props.checked &&
    css`
    position: absolute;
    top: 20%;
    left: 35%;
    height:6px;
    width:3px;
    transform: rotate(45deg);
    border-bottom: 2px solid #FFFFFF;
    border-right: 2px solid #FFFFFF;
    `}
`;

export const CheckBox = styled.div<{
    checked:boolean;
}>`
height:16px;
width:16px;
border: 2px solid #92959A;
box-sizing: border-box;
border-radius: 3px;
background-color:#FFFFFF;
${props=>
    props.checked &&
    css`
    border: 1px solid #454ADE;
    background-color:#454ADE;
`}
`;

export const OptionsText = styled(EmojiText)`
margin-left:16px;
font-family: Nunito;
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 21px;
color: #464D5E;
`;